<template>
  <div>
    <el-upload
      action=""
      class="upload-demo"
      ref="upload"
      :on-success="readFile"
      :before-upload="readFile"
      :file-list="fileList"
      :auto-upload="true">
      <el-button type="primary" size="small" @click="loadCsvFile">导入csv文件</el-button>
    </el-upload>
    
  </div>
</template>

<script>
export default {
  data () {
    return {
      fileList: []
    }
  },
  methods: {
    loadCsvFile() {
      console.log('loadCsvFile')
    },
    readFile(file) {
      var self = this
      var reader = new FileReader();
      reader.readAsText(file);  
      reader.onload = function(){  
        let res = reader.result.split('\n')
        let idx = 0
        let fields = []
        let arr = []
        for(var line of res) {
          let line_data = line.split(',')
          if (idx === 0) {
            fields = line_data
            idx += 1
            continue
          }
          let line_res = {}
          console.log(line_data)
          for (var id in line_data) {
            
            line_res[fields[id].replace('"', '').replace('"', '').trim()] = line_data[id].replace('"', '').replace('"', '').trim()
          }
          line_res.data = {
            pm10: line_res.pm10,
            pm25: line_res.pm25,
            pm10_pollution: line_res.pm10_pollution,
            pm25_pollution: line_res.pm25_pollution,
          }
          arr.push(line_res)
        }
        self.$emit("readFileFinished", arr)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/loadCsvFile.vue